/*
 * @Author: Teemo Ding
 * @Date: 2022-03-08 16:02:29
 * @LastEditTime: 2022-03-11 19:03:20
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCommunication/Components/TemplateTable/index.tsx
 */
import Table from '@/src/components/Antd/Table/SizeFittingTable';
import React, { Fragment } from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { templateInformationColumns } from '../../Template/config';
import css from './css.module.less';

const TemplateTable = ({
  dataSource,
  id,
  defaultLanguageName,
  onSendTest,
  channelType,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <Fragment>
      <h3>{getI18n('salesChannelCommunication.index.templateInformation')}</h3>
      <p>
        {getI18n('salesChannelCommunication.index.templateInformationcontent')}
      </p>
      <Table
        id={id}
        rowKey='languageTag'
        className={css.communicationTemplatesTable}
        columns={templateInformationColumns(
          onSendTest,
          defaultLanguageName,
          channelType,
          { getI18n },
        )}
        dataSource={dataSource}
        pagination={false}
      />
    </Fragment>
  );
};

export default TemplateTable;
